import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formate un montant en FCFA (`Intl.NumberFormat('fr-FR')` + suffixe),
 * logique dupliquée à l'identique sur dashboard/plan-list/property-list/ad-list.
 *
 * - `value` null/undefined → '—'
 * - `value === 0` et `zeroLabel` fourni → `zeroLabel` (ex : 'Gratuit')
 */
@Pipe({
  name: 'fcfa',
  standalone: true
})
export class FcfaPipe implements PipeTransform {
  transform(value: number | null | undefined, zeroLabel?: string): string {
    if (value === null || value === undefined) return '—';
    if (value === 0 && zeroLabel) return zeroLabel;
    return `${new Intl.NumberFormat('fr-FR').format(value)} FCFA`;
  }
}
